import { useState } from "react";

export default function Tabs({ defaultTabName, children }) {

    const [activeTab, setActiveTab] = useState(
        defaultTabName ?? (
            children?.find(c => !c.props.hide)
                ? getTabName(children.find(c => !c.props.hide), children.findIndex(c => !c.props.hide))
                : null
        )
    )

    function getTabName(tab, index) {
        return tab.props.name?.trim()?.length > 0
            ? tab.props.name.trim()
            : `tab-${index+1}`;
    }

    function getTabTitle(tab, index) {
        return tab.props.title?.trim()?.length > 0
            ? tab.props.title.trim()
            : `Tab ${index + 1}`;
    }


    return (
        <div className="tabs">
            <div className="tabs-menu">
                {
                    children?.filter(c => !c.props.hide)?.map((c, i) =>
                        <div
                            className={`tabs-menu-item${getTabName(c, i) === activeTab ? " active" : ""}`}
                            onClick={() => {
                                let tabName = getTabName(c, i);
                                if (activeTab === tabName)
                                    return;

                                setActiveTab(tabName);
                            }}>
                            {getTabTitle(c, i)}
                        </div>
                    )
                }
            </div>
            <div className="tabs-content">
                {children?.find((c, i) => getTabName(c, i) === activeTab)}
            </div>
        </div>
    );
}